module.exports = __webpack_public_path__ + "static/media/cbs-los-angeles.f78ae02a.jpg";